import type { ReactNode } from 'react';
import { useModalContext } from '../contexts/ModalContext';
import closeIcon from '@/assets/icons/close.svg';
import chevronLeftIcon from '@/assets/icons/chevron.svg';
import { cn } from '@/ui/lib/utils';
import { Icon, Button } from '@/ui/components/base';
import './modalHeader.css';

interface ModalHeaderProps {
    children: ReactNode;
    closable?: boolean;
    className?: string;
    onBack?: () => void;
}

export const ModalHeader = ({
    children,
    onBack,
    className,
    closable = false,
}: ModalHeaderProps) => {
    const { isFullscreen: isFullSize, onClose } = useModalContext();

    return (
        <div className={cn('modal-header', className)}>
            <div className="modal-header__left-icon">
                {onBack && (
                    <Button variant="ghost" onClick={onBack}>
                        <Icon src={chevronLeftIcon} alt="go back" size="extra-large" />
                    </Button>
                )}
            </div>

            <span className="modal-header__title">{children}</span>

            <div className="modal-header__right-icon">
                {(isFullSize || closable) && (
                    <Button variant="ghost" onClick={onClose}>
                        <Icon src={closeIcon} alt="close" size="extra-large" />
                    </Button>
                )}
            </div>
        </div>
    );
};
